<template>
  <box-default>

    <box-list-filter title="Relatório CES">
      <template>
        <datapicker-global @initDate="value => listFilter.initDate = value"
                           @endDate="value => listFilter.endDate = value" have-range-days-max="false"
                           range-days-init="30" variable-name="created" label="Data inicial - Data final" col="3"/>
        <datapicker-global v-if="filterResponseDate" @initDate="value => listFilter.responseInitDate = value"
                           @endDate="value => listFilter.responseEndDate = value" have-range-days-max="false"
                           range-days-init="7" variable-name="response" label="Respondido em" col="3"/>
        <input-text col="3" @contentText="value => listFilter.companyId = value" type="text" placeholder="Digite o ID"
                    label="ID da empresa" have-icon="true"/>
        <input-text col="3" @contentText="value => listFilter.companyName = value" type="text"
                    placeholder="Digite o nome" label="Nome da empresa"/>
        <input-select col="3" @selectedOption="value => listFilter.noteType = value" :options="noteOptions"
                      label="Tipo de nota"/>
        <input-text col="2" @contentText="value => listFilter.biggerThan = value" type="text" placeholder="Ex: 3"
                    label="Nota acima de" have-icon="true" mask="#"/>
        <input-text col="2" @contentText="value => listFilter.lessThan = value" type="text" placeholder="Ex: 7"
                    label="Nota abaixo de" have-icon="true" mask="#"/>
        <input-select col="3" @selectedOption="value => listFilter.journeyType = value" :options="journeyType"
                      label="Tipo de jornada"/>
        <input-checkbox @valueCheckbox="value => filterResponseDate = value" :is-checked="false" col="12"
                        label="Filtrar por data de resposta?"/>
        <btn-custom @emit-click="searchResult()" label="Pesquisar"/>
      </template>
    </box-list-filter>

    <waiting-list :loadingContent="loadingList">
      <mini-card-details dinamic-body="true" title="Muito fácil" col="4" text-align="center">
        <template>
          <div class="status">
            <span v-if="dataCode.totalEasy">{{ dataCode.totalEasy }}</span>
            <span v-else>
              -
            </span>
          </div>
        </template>
      </mini-card-details>
      <mini-card-details dinamic-body="true" title="Dentro do esperado" col="4" text-align="center">
        <template>
          <div class="status">
            <span v-if="dataCode.totalExpected">{{ dataCode.totalExpected }}</span>
            <span v-else>
               -
            </span>
          </div>
        </template>
      </mini-card-details>
      <mini-card-details dinamic-body="true" title="Muito difícil" col="4" text-align="center">
        <template>
          <div class="status">
            <span v-if="dataCode.totalHard">{{ dataCode.totalHard }}</span>
            <span v-else>
               -
            </span>
          </div>
        </template>
      </mini-card-details>

      <box-listing title="Lista de CES" have-excel="true" :loading-excel="loadingExcel"
                   :empty-state="!listContent.body.length"
                   :columns-list-header="listContent.header"
                   @emit-excel="createExcel()">
        <template>
          <tr v-for="(list, index) in listContent.body" :key="index">
            <td class="ces-employee">
              <router-link :to="'/detalhes-da-empresa/' + list.companyId + '/' + list.context"
                           v-tooltip.top-center="list.companyName">{{ list.companyName | limitTo(15) }}
              </router-link>
            </td>
            <td class="status-note note-number">
              <span class="easy" v-if="list.rating > 0  && list.rating < 4">{{ list.rating }}</span>
              <span class="middle" v-else-if="list.rating === 4">{{ list.rating }}</span>
              <span class="hard" v-else-if="list.rating > 4 && list.rating <= 7">{{ list.rating }}</span>
              <span v-else>-</span>
            </td>
            <td>
              <span>{{ list.featureTypeStr }}</span>
            </td>
            <td>
              <span v-tooltip.top-center="list.message">{{ list.message | limitTo(20) }}</span>
            </td>
            <td>
              <span>{{ list.generedDate }}</span>
            </td>
            <td>
              <span>{{ list.responseDate }}</span>
            </td>
            <td class="status-note">
              <span class="easy" v-if="list.rating > 0  && list.rating < 4">Muito difícil</span>
              <span class="middle" v-else-if="list.rating === 4">Dentro do esperado</span>
              <span class="hard" v-else-if="list.rating > 4 && list.rating <= 7">Muito fácil</span>
              <span v-else>-</span>
            </td>
          </tr>
        </template>

      </box-listing>
    </waiting-list>
  </box-default>
</template>

<script>

import TopMenu from "../../components/default/topMenu.vue";
import BoxListFilter from "../../components/layouts/boxListFilter.vue";
import BoxDefault from "../../components/layouts/boxDefault.vue";
import DatapickerGlobal from "../../components/inputs/datapickerGlobal.vue";
import InputText from "../../components/inputs/inputText.vue";
import InputSelect from "../../components/inputs/inputSelect.vue";
import BtnCustom from "../../components/buttons/btnCustom.vue";
import MiniCardDetails from "../../components/layouts/miniCardDetails.vue";
import BoxListing from "../../components/layouts/boxListing.vue";
import InputCheckbox from "../../components/inputs/inputCheckbox.vue";
import {GET_LIST_CSAT, GET_REPORT_CES} from "../../../../urlConfig";
import {ALERT_SERVICE} from "../../../../msgAlertService";
import {REQUEST_SERVICE} from "../../../../requestConfig";
import {UTIL_SERVICE} from "../../../../utils";
import WaitingList from "../../components/layouts/waitingList.vue";
import moment from "moment";


export default {
  name: "reportCES",
  components: {
    WaitingList,
    InputCheckbox,
    BoxListing,
    MiniCardDetails,
    BtnCustom,
    InputSelect,
    DatapickerGlobal,
    BoxDefault,
    BoxListFilter,
    TopMenu,
    InputText
  },
  data() {
    return {
      noteOptions: [
        {
          name: 'Selecione',
          id: ''
        },
        {
          name: 'Muito fácil',
          id: 1
        },
        {
          name: 'Dentro do esperado',
          id: 2
        },
        {
          name: 'Muito difícil',
          id: 3
        }
      ],
      journeyType: [
        {
          name: 'Selecione',
          id: ''
        },
        {
          name: 'Trial',
          id: 1,
        },
        {
          name: 'Onboarding',
          id: 2,
        },
        {
          name: 'Middle',
          id: 3,
        },
        {
          name: 'Ongoing',
          id: 4,
        }
      ],
      listFilter: {
        initDate: '',
        endDate: '',
        responseInitDate: '',
        responseEndDate: '',
        companyId: '',
        companyName: '',
        lessThan: '',
        biggerThan: '',
        noteType: '',
        journeyType: '',
        answeredIn: ''
      },
      listContent: {
        header: [
          'Nome da empresa',
          'Nota',
          'Feature Type',
          'Mensagem',
          'Data de Criação',
          'Data de Contato',
          'Status'
        ],
        body: [],
      },
      dataCode: '',
      filterResponseDate: false,
      loadingList: false,
      loadingExcel: false,
    }
  },
  methods: {
    createExcel(value) {

      this.loadingExcel = true

      let url = GET_REPORT_CES;

      if (value) {
        let today = new Date();
        let init = moment(today).subtract(29, 'days').format('YYYY-MM-DD')
        let end = moment(today).format('YYYY-MM-DD')

        url += '?initDate=' + init + '&endDate=' + end;
      } else {
        url += '?initDate=' + this.listFilter.initDate + '&endDate=' + this.listFilter.endDate;
      }


      url += '&quant=' + '9999';
      url += '&isExcelFile=' + 'true';


      if (this.listFilter.noteType) {
        url += '&noteType=' + this.listFilter.noteType
      }
      if (this.listFilter.biggerThan) {
        url += '&noteAcimaDe=' + this.listFilter.biggerThan
      }
      if (this.listFilter.lessThan) {
        url += '&noteAbaixoDe=' + this.listFilter.lessThan
      }
      if (this.listFilter.journeyType) {
        url += '&joutneyType=' + this.listFilter.journeyType
      }
      if (this.filterResponseDate) {
        url += '&initResponseDate=' + this.listFilter.responseInitDate + '&endResponseDate=' + this.listFilter.responseEndDate
      }


      REQUEST_SERVICE.get(url).then((response) => {

        let binaryData = [];
        binaryData.push(response.data);
        let urlResponse = window.URL.createObjectURL(new Blob(binaryData, {type: "text/csv"}))
        const a = document.createElement('a');
        a.href = urlResponse;
        a.download = 'Relatório-CES.csv';
        a.click();

        this.loadingExcel = false
      }).catch((reason) => {
        ALERT_SERVICE.showMsgError(reason.response.data.erros);
        this.loadingExcel = false
      });
    },
    searchResult(value) {

      let url = GET_REPORT_CES

      if (value) {
        let today = new Date();
        let init = moment(today).subtract(29, 'days').format('YYYY-MM-DD')
        let end = moment(today).format('YYYY-MM-DD')

        url += '?initDate=' + init + '&endDate=' + end;
      } else {
        url += '?initDate=' + this.listFilter.initDate + '&endDate=' + this.listFilter.endDate;
      }

      url += '&r=999999'

      if (this.listFilter.companyId) {
        url += '&companyId=' + this.listFilter.companyId
      }
      if (this.listFilter.companyName) {
        url += '&companyName=' + this.listFilter.companyName
      }
      if (this.listFilter.noteType) {
        url += '&noteType=' + this.listFilter.noteType
      }
      if (this.listFilter.biggerThan) {
        url += '&noteAcimaDe=' + this.listFilter.biggerThan
      }
      if (this.listFilter.lessThan) {
        url += '&noteAbaixoDe=' + this.listFilter.lessThan
      }
      if (this.listFilter.journeyType) {
        url += '&joutneyType=' + this.listFilter.journeyType
      }
      if (this.filterResponseDate) {
        url += '&initResponseDate=' + this.listFilter.responseInitDate + '&endResponseDate=' + this.listFilter.responseEndDate
      }

      this.loadingList = true

      UTIL_SERVICE.console("URL GET_REPORT_CES:", url);
      REQUEST_SERVICE.get(url).then((response) => {
        UTIL_SERVICE.console("RESULT GET_REPORT_CES:", response.data);


        this.dataCode = response.data;
        this.listContent.body = response.data.items
        this.loadingList = false

      }).catch((reason) => {
        ALERT_SERVICE.showMsgError(reason.response.data.erros);
        this.loadingList = false
      })
    }
  },
  beforeMount() {
    this.searchResult(true);
  },
}
</script>

<style lang="scss">
.status {
  margin-top: 20px;
  text-align: center;

  span {
    font-weight: 700;
    font-size: 30px;
  }
}

.icon {
  background: #D5DFEB;
  border-radius: 4px !important;
  padding: 6px;
  margin-top: 10px;
}

.ces-employee {
  a {
    font-weight: 400;
    font-size: 14px;
    color: #2F23D6;
    text-decoration: none;
    border-bottom: 1px solid transparent;
    transition: .2s;

    &:hover {
      border-color: #2F23D6;
    }
  }
}

.status-note {
  min-width: 182px;
  font-size: 12px;
  font-weight: 500;
  padding: 4px 16px;

  span {
    display: block;
    text-align: center;
    min-width: 61px;
  }

  .hard {
    color: var(--classic-white);
    background: var(--light-green);
    padding: 4px 26.5px;
    border-radius: 5px !important;
  }

  .middle {
    color: var(--classic-white);
    background: var(--light-yellow);
    padding: 4px 12px;
    border-radius: 5px !important;
  }

  .easy {
    color: var(--classic-white);
    background: var(--light-red);
    padding: 4px 22.7px;
    border-radius: 5px !important;
  }
}

.note-number {
  span {
    max-width: 61px;
  }
}

.tooltip {
  display: block !important;
  z-index: 10000;

  .tooltip-inner {
    background: black;
    color: white;
    border-radius: 16px !important;
    padding: 5px 10px 4px;
  }

  .tooltip-arrow {
    width: 0;
    height: 0;
    border-style: solid;
    position: absolute;
    margin: 5px;
    border-color: black;
    z-index: 1;
  }

  &[x-placement^="top"] {
    margin-bottom: 5px;

    .tooltip-arrow {
      border-width: 5px 5px 0 5px;
      border-left-color: transparent !important;
      border-right-color: transparent !important;
      border-bottom-color: transparent !important;
      bottom: -5px;
      left: calc(50% - 5px);
      margin-top: 0;
      margin-bottom: 0;
    }
  }

  &[x-placement^="bottom"] {
    margin-top: 5px;

    .tooltip-arrow {
      border-width: 0 5px 5px 5px;
      border-left-color: transparent !important;
      border-right-color: transparent !important;
      border-top-color: transparent !important;
      top: -5px;
      left: calc(50% - 5px);
      margin-top: 0;
      margin-bottom: 0;
    }
  }

  &[x-placement^="right"] {
    margin-left: 5px;

    .tooltip-arrow {
      border-width: 5px 5px 5px 0;
      border-left-color: transparent !important;
      border-top-color: transparent !important;
      border-bottom-color: transparent !important;
      left: -5px;
      top: calc(50% - 5px);
      margin-left: 0;
      margin-right: 0;
    }
  }

  &[x-placement^="left"] {
    margin-right: 5px;

    .tooltip-arrow {
      border-width: 5px 0 5px 5px;
      border-top-color: transparent !important;
      border-right-color: transparent !important;
      border-bottom-color: transparent !important;
      right: -5px;
      top: calc(50% - 5px);
      margin-left: 0;
      margin-right: 0;
    }
  }

  &[aria-hidden="true"] {
    visibility: hidden;
    opacity: 0;
    transition: opacity .15s, visibility .15s;
  }

  &[aria-hidden="false"] {
    visibility: visible;
    opacity: 1;
    transition: opacity .15s;
  }
}
</style>



// WEBPACK FOOTER //
// src/vue/pages/restricted/reports/reportCES.vue